import { Injectable, inject } from '@angular/core';
import { catchError, concatMap, from, map, of, switchMap, toArray } from 'rxjs';
import { ProcessSubscriptionService } from '@6grain/masofa-monolith-api-client/common/api/processSubscription.service';
import { ProcessSubscriptionResponse } from '@6grain/masofa-monolith-api-client/common/model/processSubscriptionResponse';
import { ProcessGroupId, processGroupId } from '@app/pages/admin/orchestration-process-groups.util';

export interface DisableModuleSubscriptionsResult {
  succeeded: number;
  failed: number;
}

/** Coordinates existing generated endpoints without changing subscription parameters. */
@Injectable({ providedIn: 'root' })
export class ModuleSubscriptionsService {
  private readonly api = inject(ProcessSubscriptionService);

  disable(groupId: ProcessGroupId) {
    return this.api.processSubscriptionsGet().pipe(
      switchMap(rows => from(rows.filter(row => row.isActive
        && processGroupId(row.processDefinitionKey ?? '') === groupId)).pipe(
        concatMap(row => this.disableSubscription(row)),
        toArray(),
      )),
      map(results => ({
        succeeded: results.filter(Boolean).length,
        failed: results.filter(result => !result).length,
      } satisfies DisableModuleSubscriptionsResult)),
    );
  }

  private disableSubscription(row: ProcessSubscriptionResponse) {
    if (!row.id || !row.name || !row.processDefinitionKey || !row.cronExpression || !row.timeZoneId) {
      return of(false);
    }
    return this.api.processSubscriptionsSubscriptionIdPut(row.id, {
      name: row.name,
      processDefinitionKey: row.processDefinitionKey,
      cronExpression: row.cronExpression,
      timeZoneId: row.timeZoneId,
      isActive: false,
      // Omitted parameters preserve the stored input, including fields hidden in safeInputJson.
    }).pipe(map(() => true), catchError(() => of(false)));
  }
}
